import { render } from "./IconButton.vue?vue&type=template&id=21e6618c&scoped=true&lang=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=21e6618c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21e6618c"

export default script